var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomTable',{ref:"table",attrs:{"id_table":"dose_actes","busy":_vm.table_busy,"hrefsRoutes":_vm.config_table_hrefs,"primaryKey":"actes_id","items":_vm.actes},on:{"update:busy":function($event){_vm.table_busy=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }